import { render, staticRenderFns } from "./OtherUserProfile.vue?vue&type=template&id=1cf9b120&"
import script from "./OtherUserProfile.vue?vue&type=script&lang=js&"
export * from "./OtherUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports